import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

import {
  AddStackRequest,
  DetailedUserInfoResponse,
  MeasurementCardResponse,
  LoginRequest,
  LoginResponse,
  AddStackResponse,
  StackStateEnumDto,
  ListStacksResponse,
  GetStackResponse,
  RefreshTokenResponse,
  RefreshRequest,
  StacksQueryPagedRequest,
} from '../.generated/admin-api';

import qs from 'qs';
import { LocalStorageService } from './localStorageService';

const axiosRequestConfig = (): AxiosRequestConfig => {
  const token = LocalStorageService.getToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    },
  };
};

export class ApiService {
  static baseUrl = 'api/v1';

  static login(
    username: string,
    password: string,
  ): Promise<AxiosResponse<LoginResponse>> {
    const loginRequest: LoginRequest = { username, password };

    return axios.post<LoginResponse>(
      `${ApiService.baseUrl}/auth/login`,
      loginRequest,
      axiosRequestConfig(),
    );
  }

  static entraLogin(idToken: string): Promise<AxiosResponse<LoginResponse>> {
    return axios.post<LoginResponse>(`${ApiService.baseUrl}/auth/entra-login`, {
      idToken,
    });
  }

  static refreshToken(
    username: string,
    refreshToken: string,
  ): Promise<AxiosResponse<RefreshTokenResponse>> {
    const refreshRequest: RefreshRequest = { userId: username, refreshToken };

    return axios.post<LoginResponse>(
      `${ApiService.baseUrl}/auth/refresh-token`,
      refreshRequest,
      axiosRequestConfig(),
    );
  }

  static forgotPassword(username: string): Promise<AxiosResponse<void>> {
    return axios.post<void>(`${ApiService.baseUrl}/auth/forgot-password`, {
      email: username,
    });
  }

  static getDetailedUserInfo(): Promise<
    AxiosResponse<DetailedUserInfoResponse>
  > {
    return axios.get<DetailedUserInfoResponse>(
      `${ApiService.baseUrl}/user-info/detailed`,
      axiosRequestConfig(),
    );
  }

  static getDepartmentMeasurementCard(
    departmentId: string,
  ): Promise<AxiosResponse<MeasurementCardResponse>> {
    return axios.get<MeasurementCardResponse>(
      `${ApiService.baseUrl}/department/${departmentId}/measurement-card`,
      axiosRequestConfig(),
    );
  }

  static getStackList(
    request: StacksQueryPagedRequest,
  ): Promise<AxiosResponse<ListStacksResponse>> {
    return axios.put<ListStacksResponse>(
      `${ApiService.baseUrl}/stack/list`,
      request,
      axiosRequestConfig(),
    );
  }

  static getStackById(
    stackId: string,
  ): Promise<AxiosResponse<GetStackResponse>> {
    return axios.get<GetStackResponse>(
      `${ApiService.baseUrl}/stack/${stackId}`,
      axiosRequestConfig(),
    );
  }

  static reserveStackNumbers(
    departmentId: string,
    deviceId: string,
  ): Promise<AxiosResponse<number[]>> {
    return axios.post<number[]>(
      `${ApiService.baseUrl}/department/${departmentId}/reserve-stack-numbers/${deviceId}`,
      null,
      axiosRequestConfig(),
    );
  }

  static createStack(
    departmentId: string,
    measurementCardId: string,
    fieldValues: Record<string, unknown>,
  ): Promise<AxiosResponse<AddStackResponse>> {
    const body: AddStackRequest = {
      departmentId: departmentId,
      measurementCardId,
      values: fieldValues,
      state: StackStateEnumDto.PRE_REGISTRATION,
    };

    return axios.post<AddStackResponse>(
      `${ApiService.baseUrl}/stack`,
      body,
      axiosRequestConfig(),
    );
  }
}
